import { useCallback, useRef, useState } from 'react';
import cn from 'classnames';

import { PdfPageImageProps } from './index.types';
import * as Styled from './index.styles';

const PdfPageImage = ({
  viewer,
  alt,
  sizes = '100vw',
  isBlind,
  onLoad,
  loading,
}: PdfPageImageProps) => {
  const [isSourceFailed, setIsSourceFailed] = useState(false);
  const isLoadEmittedRef = useRef(false);

  const emitLoad = useCallback(() => {
    if (isLoadEmittedRef.current) {
      return;
    }

    isLoadEmittedRef.current = true;
    onLoad?.();
  }, [onLoad]);

  /* 캐시된 이미지는 onLoad 이벤트가 발생하기 전에 로드가 끝날 수 있어 complete 상태를 직접 확인한다 */
  const handleImageRef = useCallback(
    (image: HTMLImageElement | null) => {
      if (image?.complete && image.naturalWidth > 0) {
        emitLoad();
      }
    },
    [emitLoad],
  );

  return (
    <picture>
      {!isSourceFailed && (
        <source
          type="image/webp"
          srcSet={`${viewer.webp1600Url} 1600w, ${viewer.webp2400Url} 2400w, ${viewer.webp3200Url} 3200w`}
          sizes={sizes}
        />
      )}
      <Styled.PageImage
        ref={handleImageRef}
        className={cn({ 'is-blind': isBlind })}
        src={viewer.fallbackUrl}
        alt={alt}
        decoding="async"
        loading={loading}
        draggable={false}
        onLoad={emitLoad}
        onError={() => setIsSourceFailed(true)}
      />
    </picture>
  );
};

export default PdfPageImage;
